export default __webpack_public_path__ + "static/media/Slider7.c98a9692.jpg";